<template>
  <div class="q-ml-md">
    <div class="row">
      <div class="row col-12">
        <div>
          <p
            class="row col-12 items-center justify-between text-h6 text-weight-bold text-brand-5 items-center texto-titulo"
          >
            Relatório de Ferramentas
            <Modal
              :tipoSelecao="'single'"
              @unidade="getFerramentas"
              :loadingValue="loadingValue"
              :dataDisable="true"
            />
          </p>
        </div>
      </div>
    </div>
    <flexmonster
      :exibir="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :types="types"
      :grid="layout"
      :exportName="'Ferramentas'"
      :updateLink="updateLink"
      :salvarType="'ferramentas'"
      :showTotals="showTotals"
      :showGrandTotals="showGrandTotals"
      :filtros="filtros"
      :gerarCsv="gerarCsv"
      :url="url"
      :urlEp="urlEp"
      :formats="formats"
      :dadosRelatorioSalvo="dados"
      @flexmonsterLoading="loadingStop"
      @enviarRespostaEp="getRelatorioSalvo"
    />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import Modal from "../components/Modal.vue";
import Flexmonster from "../components/Flexmonster.vue";
export default {
  components: { Flexmonster, Modal },
  setup() {
    const store = useStore();
    const route = useRoute();

    const slice = ref({
      columns: "",
      rows: "",
      reportFilters: "",
      measures: "",
    });
    const link = ref("");
    const layout = ref("flat");
    const loadingValue = ref("");
    const types = ref({
      numero_patrimonio: {
        type: "string",
      },
    });
    const updateLink = ref(0);
    const exibir = ref(false);
    const id = route.params.id;
    const filtros = ref("");
    const showTotals = ref("");
    const formats = ref([
      {
        name: "",
        thousandsSeparator: "",
      },
    ]);
    const url = ref("");
    const gerarCsv = ref(false);
    const urlEp = ref("");
    const dados = ref({});
    const showGrandTotals = ref("");
    const relatorioLink = localStorage.getItem("relatorioLink");

    const getFerramentas = async (data, singleValue) => {
      try {
        let filtrosObject = {
          unidade: singleValue?.label,
        };
        loadingValue.value = true;
        const response = await store.dispatch("rel/getFerramentas", {
          vendor_id: singleValue.id,
        });

        link.value = response.data.return.url;
        updateLink.value++;
        loadingValue.value = false;
        filtros.value = JSON.stringify(filtrosObject);
        exibir.value = true;
        url.value = response?.request?.responseURL;
      } catch (error) {
        console.log(error);
      }
    };

    const verificarUrl = async () => {
      if (
        id != "carregado" &&
        id != undefined &&
        id != "" &&
        id != "carregadoLink"
      ) {
        try {
          const response = await store.dispatch("rel/listarRelatoriosSalvos", {
            id,
          });
          let value = response.data.resultado.dados.map((e) => {
            e.template = JSON.parse(e.template);
            return e;
          });
          console.log(value);
          dados.value = value[0];
          urlEp.value = dados.value.url;
          url.value = dados.value.url;
          gerarCsv.value = true;
        } catch (error) {
          console.log(error);
        }
        return;
      }
      if (id == "carregado" && store.state.rel.relatorioCarregado != null) {
        dados.value = store.state.rel.relatorioCarregado;
        console.log(dados.value);
        layout.value = dados.value.layout;
        showTotals.value = dados.value.showTotals;
        showGrandTotals.value = dados.value?.showGrandTotals;

        slice.value.columns = dados.value.columns;
        slice.value.rows = dados.value.rows;
        slice.value.reportFilters = dados.value.filtros;
        slice.value.measures = dados.value.values;

        if (store.state.rel.aguardandoFiltros) {
          store.commit("rel/SET_AGUARDANDO_FILTROS", false);
          return;
        }

        slice.value?.rows.forEach((e) => {
          e.type = "number";
        });

        const response = await store.dispatch("rel/getCarregado", {
          url: dados.value.url.replace(
            /(?<=\/\/)[^.]+/,
            store.state.autenticacao.cliente[0]
          ),
        });

        link.value = response.data.return.url;
        updateLink.value++;
        loadingValue.value = false;
        url.value = response?.request?.responseURL;
        exibir.value = true;

        return;
      }

      if (
        id == "carregadoLink" &&
        relatorioLink != null &&
        relatorioLink != undefined
      ) {
        exibir.value = true;
        link.value = relatorioLink;
        updateLink.value++;
        url.value = relatorioLink;
        return;
      }
    };

    const getRelatorioSalvo = async (response) => {
      loadingValue.value = true;
      filtros.value = dados.value.filtros;
      filtros.value = dados.value.filtros;
      layout.value = dados.value.template.layout;
      showTotals.value = dados.value.template.showTotals;
      showGrandTotals.value = dados.value.template?.showGrandTotals;
      link.value = response.return.url;

      slice.value.columns = dados.value.template.columns;
      slice.value.rows = dados.value.template.rows;
      slice.value.reportFilters = dados.value.template.filtros;
      slice.value.measures = dados.value.template.values;
      exibir.value = true;

      slice.value?.rows.forEach((e) => {
        e.type = "number";
      });
      loadingValue.value = false;
      // let resultad = dados.value?.template?.values?.reduce(function (
      //   target,
      //   key
      // ) {
      //   target[key.caption.split(" ")[2]] = { type: "number" };
      //   return target;
      // },
      // {});

      // resultad?.aggregations = {
      //   number: ["sum", "average"],
      //   date: ["max", "min"],
      //   string: ["sum", "average"],
      // };

      // types.value = resultad;
    };

    const loadingStop = async (value) => {
      loadingValue.value = value;
    };

    onMounted(verificarUrl);

    return {
      getFerramentas,
      slice,
      layout,
      types,
      link,
      updateLink,
      loadingValue,
      exibir,
      filtros,
      showTotals,
      id,
      getRelatorioSalvo,
      formats,
      loadingStop,
      verificarUrl,
      url,
      urlEp,
      gerarCsv,
      dados,
      showGrandTotals,
    };
  },
};
</script>
